import {
  VStack,
  Heading,
  Text,
  SimpleGrid,
  GridItem,
  FormControl,
  FormLabel,
  useBreakpointValue,
  Box,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import DrawDateSelection from "../components/DrawDateSelection";
import { useDrawDates } from "../hooks/useDrawDates";
import { FetchResultRequestBody } from "./types";

const LatestTotoResult = () => {
  const colSpan = useBreakpointValue({ base: 4, md: 2 });

  const { drawDates, drawDays, isLoading } = useDrawDates();

  const [drawDate, setDrawDate] = useState("");
  const [drawDay, setDrawDay] = useState("");
  const [latestResults, setLatestResults] = useState([0, 0, 0, 0, 0, 0]);
  const [latestAdditionalNumber, setLatestAdditionalNumber] = useState(0);

  // Set default draw date when data loads
  useEffect(() => {
    if (drawDates.length > 0 && !drawDate) {
      setDrawDate(drawDates[0]);
      setDrawDay(drawDays[0]);
    }
  }, [drawDates, drawDays, drawDate]);

  // Update drawDay when drawDate changes
  useEffect(() => {
    if (drawDate && drawDates.length > 0) {
      const index = drawDates.indexOf(drawDate);
      if (index !== -1) {
        setDrawDay(drawDays[index]);
      }
    }
  }, [drawDate, drawDates, drawDays]);

  useEffect(() => {
    async function fetchData() {
      if (!drawDate) return;

      let body: FetchResultRequestBody;

      body = {
        date: drawDate,
      };

      const endpoint = process.env.REACT_APP_ENDPOINT as string;

      const path = "/api/results";

      try {
        const response = await axios.post(`${endpoint}${path}`, body);

        const { numbers, additionalNumber } = response.data.Items[0];
        setLatestResults(numbers);
        setLatestAdditionalNumber(additionalNumber);
      } catch (e) {
        // If fetch fails and we have dates, try the next one
        if (drawDates.length > 1) {
          setDrawDate(drawDates[1]);
          setDrawDay(drawDays[1]);
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawDate]);

  return (
    <VStack w="full" h="full" p={10} spacing={6} alignItems="flex-start">
      <VStack spacing={3} alignItems="flex-start">
        <Heading size="2xl">Latest TOTO Results</Heading>
        <Text flexDirection="row">
          Updated as of{" "}
          <Text fontWeight="bold">
            {drawDay}, {drawDate}
          </Text>
        </Text>
      </VStack>
      <SimpleGrid columns={12} columnGap={3} rowGap={6} w="full">
        {latestResults.map((result, idx) => {
          return (
            <GridItem key={idx} colSpan={colSpan}>
              <Box bg="whiteAlpha.50" w="100%" h="100%" borderRadius="lg">
                <Text fontSize="4xl" textAlign="center">
                  {result}
                </Text>
              </Box>
            </GridItem>
          );
        })}
        <GridItem colSpan={12}>
          <FormControl>
            <FormLabel>Additional Number</FormLabel>
            <GridItem colSpan={colSpan}>
              <Box bg="whiteAlpha.50" w="100%" h="100%" borderRadius="lg">
                <Text fontSize="4xl" textAlign="center">
                  {latestAdditionalNumber}
                </Text>
              </Box>
            </GridItem>
          </FormControl>
          <FormControl>
            <FormLabel>Draw Date</FormLabel>
            <DrawDateSelection
              drawDate={drawDate}
              setDrawDate={setDrawDate}
              allDrawDates={drawDates}
              allDrawDays={drawDays}
              isLoading={isLoading}
            />
          </FormControl>
        </GridItem>
      </SimpleGrid>
    </VStack>
  );
};

export default LatestTotoResult;
